import type { AuthSession } from './types';

let committed: AuthSession | null = null;

export function publishSession(session: AuthSession | null): void {
  committed = session;
}

export function getSessionSnapshot(): AuthSession | null {
  return committed;
}
